import * as analytic from '@anm/analytic';
import { useCallback } from 'react';

import routes from '../../../../routes';
import { LiveTab } from '../index';

const UPCOMING_STREAMS = 'Upcoming';
const IN_PROGRESS = 'In progress';
const PAST_STREAMS = 'Past';
const DESTINATIONS = 'Destinations';

export type MyStreamTab = typeof UPCOMING_STREAMS | typeof PAST_STREAMS | typeof DESTINATIONS | typeof IN_PROGRESS;

const { Router } = routes;

// order is important
const tabsMap: {
  [key in LiveTab]: MyStreamTab;
} = {
  upcoming: UPCOMING_STREAMS,
  'in-progress': IN_PROGRESS,
  past: PAST_STREAMS,
  destinations: DESTINATIONS
};

const trackTabsChange = (tab?: LiveTab) => {
  if (tab === 'upcoming') analytic.trackMyStreamsUpcomingTabClick();
  else if (tab === 'in-progress') analytic.trackMyStreamsInProgressTabClick();
  else if (tab === 'destinations') analytic.trackMyStreamsDestinationsTabClick();
  else if (tab === 'past') analytic.trackMyStreamsPastTabClick();
};

const useMyStreamTabs = (currentTab?: LiveTab) => {
  const defaultTab = currentTab ? tabsMap[currentTab] : UPCOMING_STREAMS;

  const sectionTabs = [UPCOMING_STREAMS, IN_PROGRESS, PAST_STREAMS, DESTINATIONS];

  const handleTabChange = useCallback((tabIndex: number) => {
    const tab = Object.keys(tabsMap)[tabIndex];

    trackTabsChange(tab as LiveTab);

    Router.pushRoute('lives', { tab });
  }, []);

  return [defaultTab, sectionTabs, handleTabChange] as const;
};

export default useMyStreamTabs;
